import { BaseComponent } from "../BaseComponent";
import { ComponentNames } from 'src/app/helper/componentNames';

export class MultiPurposeAreaComponent extends BaseComponent{
    constructor(){
        super();
        this.componentType = ComponentNames.multiPurposeAreaComponent;
    }
    bycicleAmount:number;
    skiAmount:number;
    strollerAmount:number;
}